import React, { useEffect, useState } from 'react';
import SupplierDetail from 'mpc-common/containers/SupplierMgr/component/SupplierDetail';
import { useSupplierDetail } from 'mpc-common/containers/SupplierMgr/component/models/supplierDetail';
import CompanyInfoDetail from './Detail';
import { Alert, Space } from "@bedrock/components";
import { connect } from 'react-redux';

const DetailsEntrance = (props: any) => {
    const { getSupplierDetail, openViewDetail } = useSupplierDetail()
    const { suppliersList } = props
    const [isNewSupplier, setIsNewSupplier] = useState(false)

    useEffect(() => {
        const supplier = suppliersList.find((v: any) => v.selected)
        setIsNewSupplier(supplier?.is_new)
    }, [suppliersList])

    return (
        <>
            {isNewSupplier ? <SupplierDetail {...props} /> : <CompanyInfoDetail {...props} />}
        </>

    )
}

const mapStateToProps = (state: any) => {
    return {
        suppliersList: state.account.suppliersList,
    }
}

const mapDispatchToProps = () => {
    return {}
};

export default connect(mapStateToProps, mapDispatchToProps)(DetailsEntrance);
